import React from 'react';
import Layout from '../../components/Layout/Layout';
import JustInSubCategories from '../../components/JustInSubCategories/JustInSubCategories';
import styles from './JustInSubCategoriesPage.module.css';

const JustInSubCategoriesPage = () => {
  return (
    <Layout width="1440px">
      <div className={styles.justInSubCategoriesStack}>
        <JustInSubCategories
          componentSize="Desktop 1440"
          selectedCategoryId={9}
        />
      </div>
    </Layout>
  );
};

export default JustInSubCategoriesPage;